// 2026-09-30：角色商品折扣先按单价四舍五入到一位，避免金额长尾及各入口取整不一致。
export function roleDiscountPrice(originalPrice: unknown, percent: unknown): number {
  const price = Number(originalPrice);
  if (percent === null || percent === undefined || percent === '') return price;
  const rawRate = Number(percent);
  // 折扣因子转回百分率时消除 58% 变成 57.99999999999999 的浮点误差。
  const rate = Math.abs(rawRate - Math.round(rawRate)) < 1e-10 ? Math.round(rawRate) : rawRate;
  if (!Number.isFinite(price) || !Number.isFinite(rate) || rate < 0 || rate >= 100) return price;
  const discounted = price * rate / 100;
  return Math.round((discounted + Math.abs(discounted) * Number.EPSILON) * 10) / 10;
}
